import { capitalize } from '../../../../../libs/strings/strings';

export function getLabel(category) {
  const label = category.replace(/-/g, ' ');
  return capitalize(label);
}
